import { IDotsConfirmModalProps } from "dots-ui/dotsModal";
import { AvisConfirmModal } from "./AvisConfirmModal";

export function AvisConfirmModalShort(props: Readonly<IDotsConfirmModalProps>) {
  return <AvisConfirmModal {...props} modalWidth="min(80%, 30rem)" />;
}
